import availDay from './availDay';
import availTimes from './availTimes';

const itemLimit = (item, sale, config) => {
  var timesAvail = availTimes(item, sale);
  var dayAvail = availDay(item, sale);
  var max4sale =
    dayAvail == null ||
    dayAvail['prop-m4s'] == null ||
    dayAvail['prop-m4s'].trim() == ''
      ? null
      : parseInt(dayAvail['prop-m4s'], 10);

  var limit =
    max4sale != null
      ? max4sale
      : item.limit == null || `${item.limit}`.trim() == ''
      ? null
      : item.ckmax4sale && dayAvail == null && timesAvail == null // if we need max4sale but no object available for checking max4sale then we have to set max to 0 (sold out)
      ? 0
      : parseInt(item.limit, 10);

  if (item.max_qty != null && item.max_qty > 0) {
    if (limit == null || limit > item.max_qty) {
      limit = item.max_qty;
    }
  }

  if (config.purchaseLimit != null && config.purchaseLimit > 0) {
    if (limit == null || config.purchaseLimit < limit) {
      return config.purchaseLimit;
    }
  }

  return limit > -1 ? limit : 0;
};

export default itemLimit;
